import { useOutletContext } from 'react-router-dom';
import { MileageView } from '@/components/mileage/MileageView';
import type { AppShellContext } from '@/components/layout/AppShell';

export function MileagePage() {
  const { nip, companyName } = useOutletContext<AppShellContext>();
  return <MileageView companyNip={nip} companyName={companyName} />;
}
